/**
 * ModuleIcon — icona proprietaria del modulo "Gestionale Incassi & Pagamenti"
 * secondo il Design System Gruppo Impresa Suite v1.0 (pag. 05-06).
 *
 * Layout ufficiale: quadrato con corner radius, colore identificativo
 * del modulo (Turchese Suite #0D96BB), simbolo € centrato in bianco.
 *
 * Coerente con gli altri moduli della Suite:
 *  - Gestionale di Studio      → valigetta blu    #1B3ABA
 *  - Gestionale Incassi & Pag. → € turchese       #0D96BB   (questo)
 *  - Gestionale Presenze       → calendario verde #4CAF50
 */
export function ModuleIcon({ size = 40, className = "", variant = "solid" }) {
  const bg = variant === "solid" ? "#0D96BB" : "#FFFFFF";
  const stroke = variant === "outline" ? "#0D96BB" : "transparent";
  const fg = variant === "solid" ? "#FFFFFF" : "#0D96BB";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Gestionale Incassi & Pagamenti"
    >
      <rect
        x={variant === "outline" ? "1.5" : "0"}
        y={variant === "outline" ? "1.5" : "0"}
        width={variant === "outline" ? "61" : "64"}
        height={variant === "outline" ? "61" : "64"}
        rx="14"
        fill={bg}
        stroke={stroke}
        strokeWidth={variant === "outline" ? "2" : "0"}
      />
      {/* Simbolo € centrato, tipografia Montserrat-like */}
      <text
        x="32"
        y="44"
        textAnchor="middle"
        fontFamily="Montserrat, Inter, ui-sans-serif, system-ui, sans-serif"
        fontSize="40"
        fontWeight="600"
        fill={fg}
      >
        €
      </text>
    </svg>
  );
}
